import React from 'react';
import { IntlShape, useIntl } from 'react-intl';
import { ISale, SaleType } from '../../stores';

export const saleTypeTitle = (intl: IntlShape, saleType: SaleType) =>
  saleType === SaleType.OFFER
    ? intl.formatMessage({ defaultMessage: 'offer' })
    : saleType === SaleType.ORDER
    ? intl.formatMessage({ defaultMessage: 'order' })
    : intl.formatMessage({ defaultMessage: 'invoice' });

export const SaleTypeTitle = ({ sale }: { sale: ISale }) => {
  const intl = useIntl();
  return <>{saleTypeTitle(intl, sale.type)}</>;
};
